export enum RechargeApplyStatus {
  /**
   * 待审核
   */
  WAIT_AUDIT = 0,
  /**
   * 审核通过
   */
  AUDIT_PASS = 1,
  /**
   * 已拒绝
   */
  AUDIT_REFUSE = 2
}

export const RechargeApplyStatusTextMap = {
  [RechargeApplyStatus.WAIT_AUDIT]: '待审核',
  [RechargeApplyStatus.AUDIT_PASS]: '审核通过',
  [RechargeApplyStatus.AUDIT_REFUSE]: '已拒绝'
}

export const RechargeApplyStatusColorMap = {
  [RechargeApplyStatus.WAIT_AUDIT]: '',
  [RechargeApplyStatus.AUDIT_PASS]: 'processing',
  [RechargeApplyStatus.AUDIT_REFUSE]: 'error'
}
